import { internal, template } from '../../../vendor/elix.js';

function LabelMixin(Base) {
  
  return class Label extends Base {

    static get observedAttributes() {
      return [
        ...super.observedAttributes,
        'label',
        'required'
      ];
    }

    get [internal.defaultState]() {
      return Object.assign(
        {},
        super[internal.defaultState],
        { label: undefined, required: false }
      );
    }

    attributeChangedCallback(attributeName, oldValue, newValue) {
      super.attributeChangedCallback(attributeName, oldValue, newValue);
      if (attributeName === 'label') {
        this.label = newValue;
      }
      if (attributeName === 'required') {
        this.required = newValue;
      }
    }

    get label() {
      return this[internal.state].label;
    }

    set label(label) {
      this[internal.setState]({ label });
    }

    get required() {
      return this[internal.state].required;
    }

    set required(required) {
      const isRequired = required === true || required === 'true' || this.hasAttribute('required');
      this[internal.setState]({ required: isRequired });
    }

    [internal.render](changed) {

      super[internal.render](changed);

      if (changed.label || changed.required) {
        this.renderLabel();
      }

    }

    renderLabel() {
      const labelElement = this.shadowRoot.querySelector('label');
      if (this.label) {
        labelElement.classList.add('visible');
        labelElement.textContent = this.label;
      } else {
        labelElement.classList.remove('visible');
        labelElement.textContent = '';
      }
    }

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`

        <style>

          label {
            color: var(--tp-label-mixin-font-color);
            display: none;
            font-family: var(--tp-label-mixin-font-family);
            font-size: var(--tp-label-mixin-font-size);
            line-height: normal;
            --webkit-font-smoothing: antialiased;
          }

          label.visible {
            display: block;
          }

          .inputStateContainer.disabled:not(.error) label {
            color: var(--tp-label-mixin-font-color-disabled);
          }

          .inputStateContainer:not(.disabled):not(.error):hover label {
            color: var(--tp-label-mixin-font-color-hover);
          }

          .inputStateContainer:not(.disabled):not(.error).focused label {
            color: var(--tp-label-mixin-font-color-focused);
          }

          .inputStateContainer.error label {
            color: var(--tp-label-mixin-font-color-error);
          }

        </style>

        <label for='inner'></label>
        `
      );

    }

  }
}

export default LabelMixin;
